/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Add_NoteInputs */

const cs_activity_add_note = /** @type {(inputs: Activity_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat poznámku`)
};

const en_activity_add_note = /** @type {(inputs: Activity_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add note`)
};

/**
* | output |
* | --- |
* | "Add note" |
*
* @param {Activity_Add_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const activity_add_note = /** @type {((inputs?: Activity_Add_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Add_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_add_note(inputs)
	return cs_activity_add_note(inputs)
});